export const SERVICE_TYPES = {
  SERVICE_CUSTOM: 'CUSTOM',
  SERVICE_CUSTOM_RECURRING: 'CUSTOM_RECURRING',
  SERVICE_STORAGE_BY_LOCATION: 'STORAGE_BY_LOCATION',
  SERVICE_STORAGE_BY_PRODUCT: 'STORAGE_BY_PRODUCT',
  SERVICE_SHIPPING_LABEL: 'SHIPPING_LABEL',
  SERVICE_SHIPPING_LABEL_EXTENDED_ZONE: 'SHIPPING_LABEL_EXTENDED_ZONE',
  SERVICE_INTERNATIONAL_SHIPPING_LABEL: 'INTERNATIONAL_SHIPPING_LABEL',
  SERVICE_SHIPPING_LABEL_PICKUP: 'SHIPPING_LABEL_PICKUP',
  SERVICE_RETURN_ORDER: 'RETURN_ORDER',
  SERVICE_RETURN_ORDER_LOTS: 'RETURN_ORDER_LOTS',
  SERVICE_RETURN_SHIPPING_LABEL: 'RETURN_SHIPPING_LABEL',
  SERVICE_PICK_AND_PACK: 'PICK_AND_PACK',
  SERVICE_PICK_AND_PACK_INSERT: 'PICK_AND_PACK_INSERT',
  SERVICE_PICK_AND_PACK_SERIAL_NUMBER: 'PICK_AND_PACK_SERIAL_NUMBER',
  SERVICE_PICK_AND_PACK_FRAGILE: 'PICK_AND_PACK_FRAGILE',
  SERVICE_PICK_AND_PACK_PACKAGE: 'PICK_AND_PACK_PACKAGE',
  SERVICE_REPLENISHMENT: 'REPLENISHMENT',
  SERVICE_REPLENISHMENT_LOTS: 'REPLENISHMENT_LOTS',
  SERVICE_CLAIM: 'CLAIM',
  SERVICE_WORK_ORDER: 'WORK_ORDER',
  SERVICE_DIFAL: 'DIFAL',
  SERVICE_SHIPPING_INSURANCE: 'SHIPPING_INSURANCE',
  SERVICE_PACKING_MATERIAL: 'PACKING_MATERIAL',
  SERVICE_ORDER_TECH_FEE: 'ORDER_TECH_FEE',
  SERVICE_RETURN_TECH_FEE: 'RETURN_TECH_FEE',
  SERVICE_SHIPPING_LABEL_NATURA_VENDA_DIRETA: 'SHIPPING_LABEL_NATURA_VENDA_DIRETA',
  SERVICE_SHIPPING_LABEL_NATURA_VENDA_DIRETA_ADDITIONAL_LABEL: 'SHIPPING_LABEL_NATURA_VENDA_DIRETA_ADDITIONAL_LABEL',
  SERVICE_PICK_AND_PACK_NATURA_VENDA_DIRETA: 'PICK_AND_PACK_NATURA_VENDA_DIRETA',
  SERVICE_MINIMUM_FEE: 'MINIMUM_FEE',
}

// What a store's first configuration starts with; any other currency starts without a minimum.
export const DEFAULT_MINIMUM_FEE_BY_CURRENCY = { MXN: 15000, BRL: 4000 }

export const TECH_FEE_SERVICE_TYPES = ['ORDER_TECH_FEE', 'RETURN_TECH_FEE']

export const CHANNEL_PRICES_DISCARD_CODE = 'discard_channel_prices'

export const CHANNEL_PRICE_BUSINESS_TYPES = {
  D2C: 'd2c',
  B2B: 'b2b',
}

// Unidentified returns have no order, so they have no business type and the API rejects one.
export const CHANNELS_WITHOUT_BUSINESS_TYPE = ['unidentified']

export const STORAGE_BILLING_TYPES = {
  SERVICE_STORAGE_BY_LOCATION: 'STORAGE_BY_LOCATION',
  SERVICE_STORAGE_BY_PRODUCT: 'STORAGE_BY_PRODUCT',
}

export const PACKAGE_SERVICE_TYPE_CATEGORIES = ['parcel_bag', 'jiffy_envelope', 'cubbo_box', 'customer_box']

export const RANGE_EXCLUSION_MODES = {
  RANGE_EXCLUDE_FROM: 'EXCLUDE_FROM',
  RANGE_EXCLUDE_TO: 'EXCLUDE_TO',
}

export const PRICE_MODES = {
  PRICE_MODE_PER_UNIT: 'PER_UNIT',
  PRICE_MODE_TOTAL: 'TOTAL',
}

export const NATIONAL_MX_DEPRECATED_SHIPPING_LABELS_SERVICE_TYPE_CATEGORIES = {
  SUPER_SAVER: 'SUPER_SAVER',
  LOCAL: 'LOCAL',
  PREMIUM: 'PREMIUM',
  ECONOMY: 'ECONOMY',
}

export const NATIONAL_MX_SHIPPING_LABELS_SERVICE_TYPE_CATEGORIES = {
  SAVER_PRINCIPAL_CITIES: 'SAVER_PRINCIPAL_CITIES',
  SAVER_NATIONAL: 'SAVER_NATIONAL',
  SAVER_LOCAL: 'SAVER_LOCAL',
  CUBBO_PRINCIPAL_CITIES: 'CUBBO_PRINCIPAL_CITIES',
  CUBBO_NATIONAL: 'CUBBO_NATIONAL',
  CUBBO_LOCAL: 'CUBBO_LOCAL',
  GROUND_PRINCIPAL_CITIES: 'GROUND_PRINCIPAL_CITIES',
  GROUND_NATIONAL: 'GROUND_NATIONAL',
  GROUND_LOCAL: 'GROUND_LOCAL',
  EXPRESS_PRINCIPAL_CITIES: 'EXPRESS_PRINCIPAL_CITIES',
  EXPRESS_NATIONAL: 'EXPRESS_NATIONAL',
  EXPRESS_LOCAL: 'EXPRESS_LOCAL',
}

export const NATIONAL_BR_SHIPPING_LABELS_SERVICE_TYPE_CATEGORIES = {
  GROUND_SP_CAP: 'GROUND_SP_CAP',
  GROUND_SP_INT: 'GROUND_SP_INT',
  GROUND_RJ_CAP: 'GROUND_RJ_CAP',
  GROUND_RJ_INT: 'GROUND_RJ_INT',
  GROUND_ES_CAP: 'GROUND_ES_CAP',
  GROUND_ES_INT: 'GROUND_ES_INT',
  GROUND_MG_CAP: 'GROUND_MG_CAP',
  GROUND_MG_INT: 'GROUND_MG_INT',
  GROUND_BA_CAP: 'GROUND_BA_CAP',
  GROUND_BA_INT: 'GROUND_BA_INT',
  GROUND_SE_CAP: 'GROUND_SE_CAP',
  GROUND_SE_INT: 'GROUND_SE_INT',
  GROUND_PE_CAP: 'GROUND_PE_CAP',
  GROUND_PE_INT: 'GROUND_PE_INT',
  GROUND_AL_CAP: 'GROUND_AL_CAP',
  GROUND_AL_INT: 'GROUND_AL_INT',
  GROUND_PB_CAP: 'GROUND_PB_CAP',
  GROUND_PB_INT: 'GROUND_PB_INT',
  GROUND_RN_CAP: 'GROUND_RN_CAP',
  GROUND_RN_INT: 'GROUND_RN_INT',
  GROUND_CE_CAP: 'GROUND_CE_CAP',
  GROUND_CE_INT: 'GROUND_CE_INT',
  GROUND_PI_CAP: 'GROUND_PI_CAP',
  GROUND_PI_INT: 'GROUND_PI_INT',
  GROUND_MA_CAP: 'GROUND_MA_CAP',
  GROUND_MA_INT: 'GROUND_MA_INT',
  GROUND_PA_CAP: 'GROUND_PA_CAP',
  GROUND_PA_INT: 'GROUND_PA_INT',
  GROUND_AP_CAP: 'GROUND_AP_CAP',
  GROUND_AP_INT: 'GROUND_AP_INT',
  GROUND_AM_CAP: 'GROUND_AM_CAP',
  GROUND_AM_INT: 'GROUND_AM_INT',
  GROUND_RR_CAP: 'GROUND_RR_CAP',
  GROUND_RR_INT: 'GROUND_RR_INT',
  GROUND_AM_INT_2: 'GROUND_AM_INT_2',
  GROUND_AC_CAP: 'GROUND_AC_CAP',
  GROUND_AC_INT: 'GROUND_AC_INT',
  GROUND_DF_CAP: 'GROUND_DF_CAP',
  GROUND_DF_INT: 'GROUND_DF_INT',
  GROUND_GO_CAP: 'GROUND_GO_CAP',
  GROUND_DF_INT_2: 'GROUND_DF_INT_2',
  GROUND_GO_CAP_2: 'GROUND_GO_CAP_2',
  GROUND_GO_INT: 'GROUND_GO_INT',
  GROUND_RO_CAP: 'GROUND_RO_CAP',
  GROUND_RO_INT: 'GROUND_RO_INT',
  GROUND_TO_CAP: 'GROUND_TO_CAP',
  GROUND_TO_INT: 'GROUND_TO_INT',
  GROUND_MT_CAP: 'GROUND_MT_CAP',
  GROUND_MT_INT: 'GROUND_MT_INT',
  GROUND_RO_INT_2: 'GROUND_RO_INT_2',
  GROUND_RO_INT_3: 'GROUND_RO_INT_3',
  GROUND_MS_CAP: 'GROUND_MS_CAP',
  GROUND_MS_INT: 'GROUND_MS_INT',
  GROUND_PR_CAP: 'GROUND_PR_CAP',
  GROUND_PR_INT: 'GROUND_PR_INT',
  GROUND_SC_CAP: 'GROUND_SC_CAP',
  GROUND_SC_INT: 'GROUND_SC_INT',
  GROUND_RS_CAP: 'GROUND_RS_CAP',
  GROUND_RS_INT: 'GROUND_RS_INT',
  /*
    EXPRESS_SP_CAP: "EXPRESS_SP_CAP",
    EXPRESS_SP_INT: "EXPRESS_SP_INT",
    EXPRESS_RJ_CAP: "EXPRESS_RJ_CAP",
    EXPRESS_RJ_INT: "EXPRESS_RJ_INT",
    EXPRESS_ES_CAP: "EXPRESS_ES_CAP",
    EXPRESS_ES_INT: "EXPRESS_ES_INT",
    EXPRESS_MG_CAP: "EXPRESS_MG_CAP",
    EXPRESS_MG_INT: "EXPRESS_MG_INT",
    EXPRESS_BA_CAP: "EXPRESS_BA_CAP",
    EXPRESS_BA_INT: "EXPRESS_BA_INT",
    EXPRESS_SE_CAP: "EXPRESS_SE_CAP",
    EXPRESS_SE_INT: "EXPRESS_SE_INT",
    EXPRESS_PE_CAP: "EXPRESS_PE_CAP",
    EXPRESS_PE_INT: "EXPRESS_PE_INT",
    EXPRESS_AL_CAP: "EXPRESS_AL_CAP",
    EXPRESS_AL_INT: "EXPRESS_AL_INT",
    EXPRESS_PB_CAP: "EXPRESS_PB_CAP",
    EXPRESS_PB_INT: "EXPRESS_PB_INT",
    EXPRESS_RN_CAP: "EXPRESS_RN_CAP",
    EXPRESS_RN_INT: "EXPRESS_RN_INT",
    EXPRESS_CE_CAP: "EXPRESS_CE_CAP",
    EXPRESS_CE_INT: "EXPRESS_CE_INT",
    EXPRESS_PI_CAP: "EXPRESS_PI_CAP",
    EXPRESS_PI_INT: "EXPRESS_PI_INT",
    EXPRESS_MA_CAP: "EXPRESS_MA_CAP",
    EXPRESS_MA_INT: "EXPRESS_MA_INT",
    EXPRESS_PA_CAP: "EXPRESS_PA_CAP",
    EXPRESS_PA_INT: "EXPRESS_PA_INT",
    EXPRESS_AP_CAP: "EXPRESS_AP_CAP",
    EXPRESS_AP_INT: "EXPRESS_AP_INT",
    EXPRESS_AM_CAP: "EXPRESS_AM_CAP",
    EXPRESS_AM_INT: "EXPRESS_AM_INT",
    EXPRESS_RR_CAP: "EXPRESS_RR_CAP",
    EXPRESS_RR_INT: "EXPRESS_RR_INT",
    EXPRESS_AM_INT_2: "EXPRESS_AM_INT_2",
    EXPRESS_AC_CAP: "EXPRESS_AC_CAP",
    EXPRESS_AC_INT: "EXPRESS_AC_INT",
    EXPRESS_DF_CAP: "EXPRESS_DF_CAP",
    EXPRESS_DF_INT: "EXPRESS_DF_INT",
    EXPRESS_GO_CAP: "EXPRESS_GO_CAP",
    EXPRESS_DF_INT_2: "EXPRESS_DF_INT_2",
    EXPRESS_GO_CAP_2: "EXPRESS_GO_CAP_2",
    EXPRESS_GO_INT: "EXPRESS_GO_INT",
    EXPRESS_RO_CAP: "EXPRESS_RO_CAP",
    EXPRESS_RO_INT: "EXPRESS_RO_INT",
    EXPRESS_TO_CAP: "EXPRESS_TO_CAP",
    EXPRESS_TO_INT: "EXPRESS_TO_INT",
    EXPRESS_MT_CAP: "EXPRESS_MT_CAP",
    EXPRESS_MT_INT: "EXPRESS_MT_INT",
    EXPRESS_RO_INT_2: "EXPRESS_RO_INT_2",
    EXPRESS_RO_INT_3: "EXPRESS_RO_INT_3",
    EXPRESS_MS_CAP: "EXPRESS_MS_CAP",
    EXPRESS_MS_INT: "EXPRESS_MS_INT",
    EXPRESS_PR_CAP: "EXPRESS_PR_CAP",
    EXPRESS_PR_INT: "EXPRESS_PR_INT",
    EXPRESS_SC_CAP: "EXPRESS_SC_CAP",
    EXPRESS_SC_INT: "EXPRESS_SC_INT",
    EXPRESS_RS_CAP: "EXPRESS_RS_CAP",
    EXPRESS_RS_INT: "EXPRESS_RS_INT"
    */
}

export const INTERNATIONAL_SHIPPING_LABELS_SERVICE_TYPE_CATEGORIES = {
  NORTH_AMERICA: 'NORTH_AMERICA',
  LATIN_AMERICA: 'LATIN_AMERICA',
  CARIBBEAN: 'CARIBBEAN',
  EUROPE: 'EUROPE',
  ASIA: 'ASIA',
  AFRICA: 'AFRICA',
}

export const INTERNATIONAL_SHIPPING_LABELS_RANGES = {
  INTERNATIONAL_1: 36,
  INTERNATIONAL_2: 10,
}

export const CONFIG_CUTOFF_INTERVALS = {
  // INTERVAL_YEARLY: "YEAR",
  INTERVAL_MONTHLY: 'MONTH',
  INTERVAL_WEEKLY: 'WEEK',
}

export const CONFIG_CURRENCY_BY_COUNTRY = { MX: 'MXN', BR: 'BRL', CL: 'CLP' }

export const CONFIG_CUTOFF_MODES = {
  CUTOFF_MODE_INCREMENT_BY_INTERVAL: 'INCREMENT_BY_INTERVAL',
  CUTOFF_MODE_END_OF_INTERVAL: 'END_OF_INTERVAL',
}

export const PACKING_MATERIAL_CODES = ['KRAFT_PAPER', 'BUBBLE_WRAP', 'CORN_EXTRUDATE', 'KRAFT_PAPER_AND_BUBBLE_WRAP']

export const NATURA_ADDITIONAL_BILLING_SERVICES = [
  'SHIPPING_LABEL_NATURA_VENDA_DIRETA',
  'SHIPPING_LABEL_NATURA_VENDA_DIRETA_ADDITIONAL_LABEL',
  'PICK_AND_PACK_NATURA_VENDA_DIRETA',
]
